<template>

 <b-row>
    <b-col cols="12" class="" >
      <h5 class="font-weight-semibold">Modalidade PIX </h5>
    </b-col>
    <!-- PIX -->
    <b-col md="6">
    <b-form-group >
      <label for="basic-password">Valor emissão </label>
      <b-input-group>
        <b-form-input
          disabled
          :value="'R$ '+ fees.pixValue"
          id="basic-password"
        />
      </b-input-group>
    </b-form-group>
    </b-col>
    <!-- PIX -->
    <b-col md="6">
    <b-form-group>
      <label for="basic-password">Tax recebimento (%)</label>
      <b-input-group>
        <b-form-input
          disabled
          :value="fees.pixPercentage"
          id="basic-password"
       
        />
      </b-input-group>
    </b-form-group>
    </b-col>
   
   <b-col cols="12" class="" >
      <h5 class="font-weight-semibold">Modalidade Boleto </h5>
    </b-col>

    <!-- PIX -->
    <b-col md="6">
    <b-form-group>
      <label for="basic-password">Valor emissão</label>
      <b-input-group>
        <b-form-input
          disabled
          :value=" 'R$ '+fees.boletoValue"
          id="basic-password"

        />
       
      </b-input-group>
    </b-form-group>
    </b-col>
    <!-- PIX -->
    <b-col md="6">
    <b-form-group>
      <label for="basic-password">Taxa recebimento (%)</label>
      <b-input-group>
        <b-form-input
          disabled
          :value="fees.boletoPercentage"
          id="basic-password"
         
        />
     
     
      </b-input-group>
    </b-form-group>
    </b-col>
  

  </b-row>
</template>
<script>
import { BInputGroup, BFormInput, BInputGroupPrepend, BRow, BCol, BFormCheckbox, BFormRadio, BFormGroup} from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
      BInputGroup, 
      BFormInput, 
      BInputGroupPrepend, 
      BRow, 
      BCol, 
      BFormCheckbox, 
      BFormRadio, 
      BFormGroup,
  },
 
    data() {
        return {
            status: "",
            password: "",
            show: false,
            isDisabled: false,

            // estabelecimento: {
            //     name: null,
            //     cnpj: null,
            //     id: null,
            //     email: null,
            //     apiKey: null,
            //     responsible:null
            // },
        }
    },

    created() {
  },
  computed: {
   fees() {

       return this.$store.state.estabelecimentos.estabelecimento.fees;
    },
  },

  methods: {
  async  SalvarEstabelecimento(){
    this.isDisabled = true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false
         
        })
        .catch((error) => {
          this.isDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
    //   this.isDisabled = false;
      this.show = true;
    },
  },
};
</script>
    
<style lang="">
    
</style>